// extracted by mini-css-extract-plugin
export default {"root":"_36udF","icon":"_2Vh-8","tooltip":"QXd1w"};